export default __webpack_public_path__ + "evening.png";